



































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component
export default class ComponentFinxImageUploadBase64 extends Vue {
  @Prop({ default: '', required: true }) value: string
  @Prop({ default: '', required: true }) hint: string
  @Prop({ default: 300, required: false }) imageSize: number
  @Prop({ default: false, required: false }) showSample: boolean
  @Prop({ default: ['image/jpg', 'image/jpeg', 'image/jpe'], required: false }) accept: Array<string>
  @Prop({ default: 'jpeg', required: true }) outputFormat: 'jpeg' | 'png'

  $refs!: {
    hospitalLogo: HTMLInputElement,
  }

  errors: string[] = []
  imageSrc: string = ''
  imageDimension: string = ''

  input($event) {
    this.$emit('input', $event ? $event.target.value : '')
  }

  formatAccept(list: string[]) {
    return list.toString().replaceAll('image/', '.')
  }

  clear() {
    this.$refs.hospitalLogo.value = ''
    this.imageSrc = ''
  }

  activateFileInput() {
    this.$refs.hospitalLogo.click()
  }

  fileSelect(event: Event) {
    // @ts-ignore
    const imageFile = event.target.files[0]

    if (!this.accept.includes(imageFile.type)) {
      this.errors.push('Formato inválido.')
      this.$refs.hospitalLogo.value = ''
      return
    }

    this.errors = []
    const reader: FileReader = new FileReader()
    reader.readAsDataURL(imageFile)

    reader.onload = (ev: Event) => {
      // @ts-ignore
      const imageURL = ev.target.result
      const image = document.createElement('img')
      image.src = imageURL

      image.onload = (e: Event) => {
        const canvas = document.createElement('canvas')
        // @ts-ignore
        this.imageDimension = (e.target.width >= e.target.height) ? `width: 100%; max-width: ${this.imageSize}` : `width: ${this.imageSize}`
        // @ts-ignore
        const ratio = (e.target.width >= e.target.height) ? this.imageSize / e.target.width : this.imageSize / e.target.height
        // @ts-ignore
        canvas.width = (e.target.width >= e.target.height) ? this.imageSize : e.target.width * ratio
        // @ts-ignore
        canvas.height = (e.target.width >= e.target.height) ? e.target.height * ratio : this.imageSize
        const context = canvas.getContext('2d')
        // @ts-ignore
        context.drawImage(image, 0, 0, canvas.width, canvas.height)
        // @ts-ignore
        this.imageSrc = context.canvas.toDataURL(`image/${this.outputFormat}`, 100)

        if (this.showSample && this.imageSrc !== '') {
          const sampleImage = document.getElementById('sample-image')
          if (sampleImage !== null) sampleImage.setAttribute('src', this.imageSrc)
          this.$emit('input', this.imageSrc)
        }
      }
    }
  }
}
